module.exports = __webpack_public_path__ + "img/shenlan.16e449c3.png";